import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, unref as _unref, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a7f83e16"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main_task" }
const _hoisted_2 = { class: "list_search" }
const _hoisted_3 = { class: "search_header" }
const _hoisted_4 = {
  class: "flexWrap",
  style: {"width":"90%"}
}
const _hoisted_5 = { class: "header_nr flexAlign" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nr_left" }, "签字表单类型：", -1))
const _hoisted_7 = { class: "header_nr flexAlign" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nr_left" }, "任务标题：", -1))
const _hoisted_9 = { class: "header_nr flexAlign" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nr_left" }, "任务状态：", -1))
const _hoisted_11 = {
  class: "header_nr flexAlign",
  style: {"margin-left":"20px"}
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<div style=\"height:10px;\" data-v-a7f83e16></div><div class=\"legend\" data-v-a7f83e16><span class=\"lg\" data-v-a7f83e16><i class=\"block\" style=\"background:#fde2e2;border:1px solid #f56c6c;\" data-v-a7f83e16></i>逾期未签字（已过要求完成时间）</span><span class=\"lg\" data-v-a7f83e16><i class=\"block\" style=\"background:#fdf1e0;border:1px solid #e6a23c;\" data-v-a7f83e16></i>环节未设置要求完成时间</span></div>", 2)
const _hoisted_16 = ["title", "onClick"]
const _hoisted_17 = { class: "line" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "k" }, "要求完成：", -1))
const _hoisted_19 = { class: "line" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "k" }, "执行人：", -1))
const _hoisted_21 = { class: "line" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "k" }, "执行人签字：", -1))
const _hoisted_23 = { class: "line" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "k" }, "审核人签字：", -1))
const _hoisted_25 = {
  key: 1,
  class: "deleted"
}
const _hoisted_26 = { class: "qp" }
const _hoisted_27 = { class: "my-header" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "任务详情", -1))
const _hoisted_29 = {
  class: "flexEnd",
  style: {"padding":"20px"}
}

import { onMounted, ref, nextTick } from 'vue'
import { Search, Close } from '@element-plus/icons-vue'
import {
	reqFormInstanceSignTemplateList,
	reqFormInstanceSignSummaryList
} from '@/api/forminstanceApi'
import TaskDetails from '@/components/TaskDetails.vue'


export default /*#__PURE__*/_defineComponent({
  name: 'SignFormSummary',
  setup(__props) {

const loading = ref<boolean>(false)
const pageIndex = ref<number>(1)
const pageSize = ref<number>(10)
const pages = ref({ totalCount: 0 })
const tableData = ref<any[]>([])
// 环节列定义（由后端按所选模板返回）
const stepCols = ref<any[]>([])
// 签字表单类型下拉
const templateList = ref<any[]>([])

const search = ref({
	formid: '',
	tasktitle: '',
	taskstatus: ''
})

onMounted(() => {
	loadTemplates()
	getList()
})

// 签字表单类型下拉
const loadTemplates = () => {
	reqFormInstanceSignTemplateList({}).then((res: any) => {
		if (res.status === 1) {
			templateList.value = res.datalist || []
		}
	})
}

const getList = () => {
	loading.value = true
	reqFormInstanceSignSummaryList({
		pageIndex: pageIndex.value,
		pageSize: pageSize.value,
		formid: search.value.formid,
		tasktitle: search.value.tasktitle,
		taskstatus: search.value.taskstatus
	}).then((res: any) => {
		tableData.value = res.data || []
		pages.value.totalCount = res.totalCount || 0
		stepCols.value = res.steps || []
		loading.value = false
	}).catch(() => {
		loading.value = false
	})
}

const searchList = () => {
	pageIndex.value = 1
	getList()
}

const resetSearch = () => {
	search.value = { formid: '', tasktitle: '', taskstatus: '' }
	searchList()
}

const handleSizeChange = (val: number) => {
	pageSize.value = val
	getList()
}

const handleCurrentChange = (val: number) => {
	pageIndex.value = val
	getList()
}

// 取某行第 ci 个环节的数据（后端 stepcells 与 stepCols 顺序一致）
const getCell = (row: any, ci: number): any => {
	const cells = row && row.stepcells ? row.stepcells : []
	return cells[ci] || null
}

// 列头：优先显示环节简述，没有则回退到流程描述
const colLabel = (col: any, ci: number): string => {
	const name = (col && (col.brief || col.stepdesc)) || ''
	return name ? `环节${ci + 1}：${name}` : `环节${ci + 1}`
}

// 单元格底色：red 逾期未签字 / orange 未设置要求完成时间 / deleted 环节不存在
const cellClass = (cell: any): string => {
	if (!cell) return ''
	if (cell.exists !== '1') return 'cell-deleted'
	if (cell.flag === 'red') return 'cell-red'
	if (cell.flag === 'orange') return 'cell-orange'
	return ''
}

// 用 cell-style 给整个单元格上色（背景色作用于 td）
const cellStyle = ({ row, columnIndex }: any) => {
	// 前5列为固定信息列，不参与环节底色
	if (columnIndex < 5) return {}
	const cell = getCell(row, columnIndex - 5)
	const cls = cellClass(cell)
	if (cls === 'cell-red') return { backgroundColor: '#fde2e2' }
	if (cls === 'cell-orange') return { backgroundColor: '#fdf1e0' }
	if (cls === 'cell-deleted') return { backgroundColor: '#f5f5f5' }
	return {}
}

// 签字文案：需签字且已签 -> 姓名+时间；需签字未签 -> 未签字；不需要签字 -> 无需签字
const signText = (cell: any, role: string): string => {
	if (!cell) return ''
	if (role === 'executor') {
		if (cell.executorsign !== '1') return '无需签字'
		return cell.executorsignname ? `${cell.executorsignname} ${cell.executorsigntime || ''}`.trim() : '未签字'
	}
	if (cell.reviewersign !== '1') return '无需签字'
	return cell.reviewersignname ? `${cell.reviewersignname} ${cell.reviewersigntime || ''}`.trim() : '未签字'
}

// ===== 点击环节 -> 打开任务详情并定位到该环节 =====
const taskDetails = ref<boolean>(false)
const taskDetailsShow = ref<boolean>(false)
const focusStepId = ref<string>('')
const detailForm = ref<any>({})

// 已删除的环节无法定位，不可点击
const canOpen = (cell: any): boolean => {
	return !!cell && cell.exists === '1' && !!cell.stepid
}

const openStepDetail = (row: any, cell: any) => {
	if (!canOpen(cell)) return
	const c = row && row.cell ? row.cell : {}
	// TaskDetails 内部会按任务id重新加载完整任务数据，这里只需最小字段
	detailForm.value = {
		id: c.tid,
		tasktitle: c.tasktitle || '',
		projectid: c.projectid || 0,
		projectname: c.projectname || '',
		code: c.code || '',
		startdate: c.startdate || '',
		enddate: c.enddate || '',
		status: c.taskstatus || 0,
		uuid: c.taskuuid || ''
	}
	focusStepId.value = String(cell.stepid)
	// 重建组件，确保定位逻辑重新执行
	taskDetailsShow.value = false
	nextTick(() => {
		taskDetailsShow.value = true
	})
	taskDetails.value = true
}

const cancelDetails = () => {
	taskDetails.value = false
	getList()
}

const taskListsx = () => {
	getList()
	taskDetails.value = false
}

// 任务状态：0未启动 1进行中 2关闭 3提交待审核 4完成
const taskStatusText = (s: any): string => {
	switch (String(s)) {
		case '0': return '未启动'
		case '1': return '进行中'
		case '2': return '关闭'
		case '3': return '提交待审核'
		case '4': return '完成'
		default: return '-'
	}
}
const taskStatusType = (s: any): 'success' | 'danger' | 'warning' | 'info' => {
	switch (String(s)) {
		case '4': return 'success'
		case '2': return 'danger'
		case '3': return 'warning'
		case '1': return 'info'
		default: return 'info'
	}
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_el_select, {
              size: "small",
              modelValue: search.value.formid,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search.value.formid) = $event)),
              placeholder: "全部",
              clearable: "",
              style: {"width":"180px"}
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(templateList.value, (t, i) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: i,
                    label: t.formname,
                    value: t.id
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_el_input, {
              size: "small",
              modelValue: search.value.tasktitle,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((search.value.tasktitle) = $event)),
              style: {width:'160px'},
              placeholder: "请输入任务标题",
              onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (searchList()), ["enter","native"]))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode(_component_el_select, {
              size: "small",
              modelValue: search.value.taskstatus,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((search.value.taskstatus) = $event)),
              placeholder: "全部",
              clearable: "",
              style: {"width":"130px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "未启动",
                  value: "0"
                }),
                _createVNode(_component_el_option, {
                  label: "进行中",
                  value: "1"
                }),
                _createVNode(_component_el_option, {
                  label: "关闭",
                  value: "2"
                }),
                _createVNode(_component_el_option, {
                  label: "提交待审核",
                  value: "3"
                }),
                _createVNode(_component_el_option, {
                  label: "完成",
                  value: "4"
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_el_button, {
              plain: "",
              type: "primary",
              size: "small",
              icon: _unref(Search),
              onClick: _cache[4] || (_cache[4] = ($event: any) => (searchList()))
            }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            }, 8, ["icon"]),
            _createVNode(_component_el_button, {
              size: "small",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (resetSearch()))
            }, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _hoisted_14,
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      "empty-text": "暂无数据",
      data: tableData.value,
      border: "",
      "header-cell-style": {color:'#000',backgroundColor:'#fafbfd'},
      "cell-style": cellStyle
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "index",
          width: "60",
          label: "序号",
          align: "center",
          fixed: "left"
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.tasktitle",
          label: "任务标题",
          "min-width": "160",
          "show-overflow-tooltip": "",
          fixed: "left"
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.startdate",
          label: "任务开始时间",
          width: "120",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.enddate",
          label: "任务结束时间",
          width: "120",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "任务状态",
          width: "100",
          align: "center"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_tag, {
              type: taskStatusType(scope.row.cell.taskstatus),
              size: "small"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(taskStatusText(scope.row.cell.taskstatus)), 1)
              ]),
              _: 2
            }, 1032, ["type"])
          ]),
          _: 1
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stepCols.value, (col, ci) => {
          return (_openBlock(), _createBlock(_component_el_table_column, {
            key: ci,
            label: colLabel(col, ci),
            width: "230",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("div", {
                class: _normalizeClass(["step_cell", [cellClass(getCell(scope.row, ci)), canOpen(getCell(scope.row, ci)) ? 'clickable' : '']]),
                title: canOpen(getCell(scope.row, ci)) ? '点击查看该环节详情' : '',
                onClick: ($event: any) => (openStepDetail(scope.row, getCell(scope.row, ci)))
              }, [
                (getCell(scope.row, ci) && getCell(scope.row, ci).exists === '1')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", _hoisted_17, [
                        _hoisted_18,
                        _createTextVNode(_toDisplayString(getCell(scope.row, ci).steptime || '-'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _hoisted_20,
                        _createTextVNode(_toDisplayString(getCell(scope.row, ci).executor || '-'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _hoisted_22,
                        _createTextVNode(_toDisplayString(signText(getCell(scope.row, ci), 'executor')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _hoisted_24,
                        _createTextVNode(_toDisplayString(signText(getCell(scope.row, ci), 'reviewer')), 1)
                      ])
                    ], 64))
                  : (_openBlock(), _createElementBlock("div", _hoisted_25, "已删除"))
              ], 10, _hoisted_16)
            ]),
            _: 2
          }, 1032, ["label"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, loading.value]
    ]),
    _createElementVNode("div", _hoisted_26, [
      _createVNode(_component_el_dialog, {
        modelValue: taskDetails.value,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((taskDetails).value = $event)),
        "show-close": false,
        fullscreen: ""
      }, {
        header: _withCtx(({ close, titleId, titleClass }) => [
          _createElementVNode("div", _hoisted_27, [
            _hoisted_28,
            _createVNode(_component_el_icon, {
              class: "delicon",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (cancelDetails()))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Close))
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          (taskDetailsShow.value)
            ? (_openBlock(), _createBlock(TaskDetails, {
                key: 0,
                form: detailForm.value,
                "focus-step-id": focusStepId.value,
                "focus-target": "sign",
                onTaskListsx: taskListsx
              }, null, 8, ["form", "focus-step-id"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_29, [
      _createVNode(_component_el_pagination, {
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange,
        currentPage: pageIndex.value,
        "onUpdate:currentPage": _cache[8] || (_cache[8] = ($event: any) => ((pageIndex).value = $event)),
        "page-sizes": [10, 20, 30],
        "page-size": pageSize.value,
        "onUpdate:page-size": _cache[9] || (_cache[9] = ($event: any) => ((pageSize).value = $event)),
        layout: "total, sizes, prev, pager, next, jumper",
        total: pages.value.totalCount
      }, null, 8, ["currentPage", "page-size", "total"])
    ])
  ]))
}
}

})